import React from "react";
import useModal from "../../../hooks/useModal";
import Button from "../../atoms/Button";
import Modal from "../../molecules/Modal";
import { MdNotificationAdd } from "react-icons/md";
import ModalCreateAnuncio from "./ModalCreateAnuncio";

const CreateAnuncio = ({ refetch }) => {
    const { open, close, isOpen } = useModal();

    return(
        <div>
            <Button text={<MdNotificationAdd size={22} />} bgColor="green" onClick={open} width="w-10"/>
            {isOpen &&
                <Modal title="Crear aviso" onClose={close}>
                    <ModalCreateAnuncio refetch={refetch} onClose={close} />
                </Modal>
            }
        </div>
    );
};

export default CreateAnuncio;